<template>
  <div class="scope-first-container">
    <Steps :current="0">
      <Step title="填写订单信息"></Step>
      <Step title="选择支付方式"></Step>
      <Step title="完成"></Step>
    </Steps>
    <template v-if="isShowLoading">
      <loading></loading>
    </template>
    <div class="common-second" id="firstStep">
      <Form
        ref="totalInfo"
        :model="totalInfo"
        :label-width="96"
        label-position="left"
        :rules="ruleValidate"
        :style="{ marginTop: '50px' }"
      >
        <h3>
          预订信息
          <span
            class="reservations"
            :style="{ color: '#4b7ff0' }"
            @click="toggleShowReservations(destineArr.strbookdescription)"
            >预订说明</span
          >
        </h3>

        <Table
          class="ticket-table"
          width="1073"
          :columns="ticketColumn1"
          :data="destineArr.orderInfo"
        ></Table>
        <FormItem
          label="订单总金额："
          class="fr position-form-item"
          :label-width="96"
        >
          <p class="pay-money">
            <span class="SHCN-M">￥</span>
            <span
              v-if="!routeType"
              class="SHCN-B"
              v-html="(destineArr.xjcount - couponMoney).toFixed(2) + '元'"
            ></span>
            <span v-else class="SHCN-B" v-html="'0.00元'"></span>
          </p>
        </FormItem>
        <div class="couponZoon" v-if="showCoupon">
          <Checkbox
            v-model="useCoupon"
            ref="useCouponCheckbox"
            :disabled="useDisabled"
            >使用优惠券，{{ couponInfor.preferential_rule }}</Checkbox
          >
        </div>
        <hr />
        <div v-if="firstStepShow === '1' && !routeType">
          <div>
            <div
              class="margin-top-50"
              v-for="(n, idx) in destineArr.numCount"
              :key="idx + 'aa'"
            >
              <h4 class="inline-block-h3" v-html="'添加入园人信息' + n"></h4>
              <div
                v-if="isShowContact"
                class="topContacts"
                @click="choosePerson1(n)"
              >
                常用联系人
              </div>
              <FormItem label="姓名：" :prop="'name' + n">
                <Input
                  v-model="totalInfo['name' + n]"
                  placeholder="请输入证件上的实际姓名"
                  style="width: 280px"
                />
              </FormItem>
              <FormItem label="身份证号：" :prop="'ID' + n">
                <Input
                  v-model="totalInfo['ID' + n]"
                  placeholder="请正确输入证件号码，可用于检票"
                  style="width: 280px"
                  @on-keyup="checkRequire(n)"
                  :data-use="n"
                />
              </FormItem>

              <!--<FormItem label="手机号码：" :prop="'phoneNumber'+n">-->
              <!--<Input v-model="totalInfo['phoneNumber'+n]" placeholder="请输入手机号码，用于接收短信" clearable style="width: 280px" @on-change="checkRequire()"/>-->
              <!--</FormItem>-->
            </div>
          </div>

          <!--<div class="margin-top-50">-->
          <!--<h4>添加入园人信息2</h4>-->
          <!--<FormItem label="姓名：" prop="name2">-->
          <!--<Input v-model="totalInfo.name2" placeholder="请输入证件上的实际姓名" clearable style="width: 280px" />-->
          <!--</FormItem>-->
          <!--<FormItem label="身份证号：" prop="ID2">-->
          <!--<Input v-model="totalInfo.ID2" placeholder="请正确输入证件号码，可用于检票" clearable style="width: 280px" />-->
          <!--</FormItem>-->
          <!--<FormItem label="手机号码：" prop="phoneNumber2">-->
          <!--<Input v-model="totalInfo.phoneNumber2" placeholder="请输入手机号码，用于接收短信" clearable style="width: 280px" />-->
          <!--</FormItem>-->
          <!--</div>-->

          <hr />

          <!--<div class="clearAll">-->
          <!--<h3 class="fl">入园信息</h3>-->
          <!--&lt;!&ndash;<div class="topContacts fr">+常用联人</div>&ndash;&gt;-->
          <!--</div>-->

          <!--<div class="contacts">-->
          <!--<Checkbox :value="item"  v-for="(item,index) in destineArr.lingpiaouserList"  v-if="index < maxShow" :disabled=" !item.iselect&&singleFlag" @on-change="checksingleChange(item)">-->
          <!--<span v-html="item.username"></span>-->
          <!--</Checkbox>-->
          <!--<span class="pointer-cursor" @click="checkMore">查看更多</span>-->
          <!--</div>-->
        </div>
        <div class="clearAll">
          <h3 class="inline-block-h3">
            {{ routeType === "lc" ? "购买人信息" : "领票人信息" }}
          </h3>
          <div
            v-if="isShowContact && !routeType"
            class="topContacts"
            @click="choosePerson"
          >
            常用联系人
          </div>

          <Modal
            v-model="modal1"
            width="530"
            :closable="true"
            :mask-closable="false"
          >
            <p slot="header">选择常用联系人</p>
            <div
              class="ivu-modal-body-div"
              style="height: 400px; overflow-y: auto"
            >
              <RadioGroup class="mb1" v-model="lprxx">
                <Radio
                  :label="JSON.stringify(item)"
                  v-for="item in lingpiaouserList"
                  :key="item.seq"
                >
                  <span class="span1" v-html="item.username"></span>
                  <span class="ml1">{{ item.mobile | phoneFilters }}</span>
                  <span class="ml2" v-html="item.zjhm"></span>
                </Radio>
              </RadioGroup>
            </div>
            <div slot="footer" style="text-align: center">
              <Button type="primary" class="op-btns ok-btn" @click="chooseLpr"
                >确定</Button
              >
              <Button class="op-btns cancel-btn" @click="hideModal('modal1')"
                >取消</Button
              >
            </div>
          </Modal>

          <Modal
            v-model="modal2"
            width="530"
            :closable="true"
            :mask-closable="false"
          >
            <p slot="header">选择常用联系人</p>
            <div
              class="ivu-modal-body-div"
              style="height: 400px; overflow-y: auto"
            >
              <RadioGroup class="mb1" v-model="lprxx1">
                <Radio
                  :label="JSON.stringify(item)"
                  v-for="item in lingpiaouserList"
                  :key="item.seq"
                  :disabled="
                    disableArr.indexOf(item.zjhm) !== -1 &&
                    item.zjhm !== ableObj[personNum]
                  "
                >
                  <span class="span1" v-html="item.username"></span>
                  <span class="ml1">{{ item.mobile | phoneFilters }}</span>
                  <span class="ml2" v-html="item.zjhm"></span>
                </Radio>
              </RadioGroup>
            </div>
            <div slot="footer" style="text-align: center">
              <Button type="primary" class="op-btns ok-btn" @click="chooseLpr1"
                >确定</Button
              >
              <Button class="op-btns cancel-btn" @click="hideModal('modal2')"
                >取消</Button
              >
            </div>
          </Modal>
        </div>

        <FormItem label="姓名：" prop="namezj">
          <Input
            v-model="totalInfo.namezj"
            placeholder="请输入证件上的实际姓名"
            style="width: 280px"
            :disabled="$route.query.type === 'lc' ? true : false"
          />
        </FormItem>
        <FormItem label="身份证号：" prop="IDzj">
          <Input
            v-model="totalInfo.IDzj"
            placeholder="请正确输入证件号码，可用于检票"
            style="width: 280px"
            :disabled="$route.query.type === 'lc' ? true : false"
          />
        </FormItem>
        <FormItem label="手机号码：" prop="phoneNumberzj">
          <Input
            v-model="totalInfo.phoneNumberzj"
            placeholder="请输入手机号码，用于接收短信"
            style="width: 280px"
            :disabled="$route.query.type === 'lc' ? true : false"
          />
        </FormItem>
        <FormItem
          label="验证码："
          prop="verificationCode"
          v-if="!isShowContact"
        >
          <Input
            v-model="totalInfo.verificationCode"
            placeholder="请输入验证码"
            style="width: 280px"
          />
          <Button
            @click="getYzm()"
            :disabled="
              !/^1[345789]\d{9}$/.test(totalInfo.phoneNumberzj) ||
              yzmObj.timelimit
            "
            v-html="yzmObj.tishi"
            class="margin-left-10"
          ></Button>
        </FormItem>
        <FormItem label="旅游卡：" v-if="routeType">
          <Select
            v-model="travelCardData.key"
            style="width: 280px"
            @on-change="handleTravelCardChange"
          >
            <Option
              :value="itemA.key"
              v-for="(itemA, idx) in travelCardLists"
              :key="itemA.key + idx"
              >{{ itemA.value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          class="clear-default-left"
          :label-width="labelWidth"
          v-if="!routeType"
        >
          <Checkbox v-model="totalInfo.cyuser">设为常用联系人</Checkbox>
        </FormItem>

        <h3 v-if="!routeType">备注信息</h3>
        <div class="position-rel" v-if="!routeType">
          <Input
            v-model="totalInfo.mask"
            type="textarea"
            :rows="2"
            placeholder="请留下您的备注信息,100字以内~"
            :maxlength="100"
          />
          <div class="zishu">
            已输入
            <span>{{ totalInfo.mask.length }}</span
            >/100字
          </div>
        </div>
        <!-- <hr> -->
        <!--<FormItem label="" class="clear-default-left">-->
        <!--<Checkbox v-model="totalInfo.readed">已阅读并同意易旅宝官网预订条款</Checkbox>-->
        <!--</FormItem>-->

        <FormItem
          class="clear-default-left bottom-item"
          :label-width="labelWidth"
        >
          <Button
            type="primary"
            class="submit-order SHCN-M"
            @click="goToBuy"
            v-if="routeType"
            >去支付</Button
          >
          <Button
            type="primary"
            class="submit-order SHCN-M"
            @click="handleSubmit('totalInfo', totalInfo)"
            v-else
            >提交订单</Button
          >
        </FormItem>
      </Form>
      <Modal
        v-model="modalLogin"
        title="请登录"
        width="600"
        class="modal-contacts login-modal"
      >
        <div class="login-div">
          <Form
            ref="totalInfo1"
            :model="totalInfo1"
            :label-width="96"
            label-position="left"
            :rules="ruleValidate1"
          >
            <FormItem label="手机号码：" prop="phoneNumbeLogin">
              <Input
                v-model="totalInfo1.phoneNumbeLogin"
                placeholder="请输入您的手机号码"
                style="width: 175px"
              />
            </FormItem>
            <FormItem label="密码：" prop="passwordLogin">
              <Input
                v-model="totalInfo1.passwordLogin"
                placeholder="请输入您的账号密码"
                style="width: 175px"
                type="password"
              />
            </FormItem>
            <Checkbox v-model="isSelect" label="Eat" class="fl"
              >记住密码</Checkbox
            >
            <router-link
              target="_blank"
              to="/registration/touristPaswd"
              class="fr"
            >
              <span class="hover_underline">忘记密码？</span>
            </router-link>
            <br />
            <FormItem>
              <Button
                @click="handleSubmit1('totalInfo1', totalInfo1)"
                type="primary"
                long
                class="op-btns ok-btn mg1"
                style="height: 40px"
              >
                <span style="font-size: 16px"
                  >登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</span
                >
              </Button>
            </FormItem>
          </Form>
        </div>
      </Modal>
      <loading v-if="spinShow"></loading>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { reduceObjInArr, distinct } from "../../../libs/common.js";
export default {
  name: "firstStepOfTicketPay",
  data: function () {
    let that = this;
    return {
      isShowLoading: false,
      routeType: this.$route.query.type,
      userName: sessionStorage.getItem("userName"),
      spinShow: false,
      lprxx: null,
      lprxx1: null,
      lc: {
        IDzj: "",
        phoneNumberzj: "",
      },
      totalInfo: {
        people: [],
        name1: "",
        ID1: "",
        namezj: this.lingpiaouser ? this.lingpiaouser.username : "",
        IDzj: this.lingpiaouser ? this.lingpiaouser.zjhm : "",
        phoneNumberzj: this.lingpiaouser ? this.lingpiaouser.mobile : "",
        verificationCode: "",
        mask: "",
        cyuser: this.lingpiaouser ? true : "",
      },
      totalInfo1: {
        phoneNumbeLogin: "",
        passwordLogin: "",
      },
      // showReservations: false,
      modal1: false,
      modal2: false,
      ticketColumn1: [
        {
          title: "票种",
          key: "szcrowdkindname",
          align: "center",
        },
        {
          title: "产品名称",
          key: "sztickettypename",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("span", params.row.sztickettypename),
              h(
                "span",
                params.row.starttime
                  ? "(" + params.row.starttime + "-" + params.row.endtime + ")"
                  : ""
              ),
            ]);
          },
        },
        {
          title: "游玩日期",
          align: "center",
          render: (h, params) => {
            return h("span", this.destineArr.playtime);
          },
        },
        {
          title: "单价",
          // key: 'price',
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.routeType === "lc" ? `￥0.00` : `￥${params.row.price}`
            );
          },
        },
        {
          title: "优惠",
          // key:'d',
          align: "center",
          render: (h, params) => {
            return h("div", "--");
          },
        },
        {
          title: "票数",
          key: "aaa",
          align: "center",
          render: function (h, params) {
            return h("div", [
              h("Button", {
                class: {
                  btn3: true,
                  bg1: false,
                },
                props: {
                  type: "primary",
                  size: "small",
                  // icon:'minus-round',
                  icon: "md-remove",
                },
                style: {
                  marginRight: "11px",
                  lineHeight: "11px",
                  borderRadius: "2px 0 0 2px",
                },
                on: {
                  click: function () {
                    if (params.row.icrowdkindid > 0) {
                      that.orderReduce(params.row.icrowdkindid);
                    }
                  },
                },
              }),
              h("Input", {
                class: {
                  inpt1: true,
                },
                props: {
                  type: "text",
                  size: "small",
                  // readonly: true,
                  value: params.row.num,
                  // model:this.number,
                  number: true,
                  // maxlength:2,
                  // 'v-model':this.number
                },
                on: {
                  "on-blur": (event) => {
                    that.orderInput({
                      id: params.row.icrowdkindid,
                      value: parseInt(event.target.value),
                    });
                  },
                },
              }),
              h("Button", {
                class: {
                  btn3: true,
                },
                props: {
                  type: "primary",
                  size: "small",
                  // icon:'plus-round',
                  icon: "md-add",
                },
                style: {
                  marginLeft: "11px",
                  lineHeight: "11px",
                  borderRadius: "0 2px 2px 0",
                },
                on: {
                  click: () => {
                    that.$store.commit("orderAdd", {
                      id: params.row.icrowdkindid,
                      type: that.$route.query.type,
                    });
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "金额",
          // key: 'xjmoney',
          align: "center",
          className: "demo-table-price-column",
          render: (h, params) => {
            return h(
              "span",
              this.routeType === "lc"
                ? `￥0.00`
                : `￥${params.row.xjmoney.toFixed(2)}`
            );
          },
        },
      ],
      maxShow: 10,
      // readed: false,
      writeNum: 0,
      checkList: [],
      singleFlag: false,
      yzmObj: {
        tishi: "获取验证码",
        timelimit: false,
      },
      modalLogin: false,
      ruleValidate1: {
        phoneNumbeLogin: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            required: true,
            message: "请输入正确的手机号码",
            pattern: /^1[34578]\d{9}$/,
            trigger: "blur",
          },
        ],
        passwordLogin: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      couponInfor: {},
      useDisabled: true, // true是禁止选择，false可以选择
      showUseCoupon: false,
      useCoupon: false,
      showCoupon: false,
      couponMoney: 0,
      couponId: "",
      isSelect: false,
      personNum: "1",
      disableArr: [],
      ableObj: {},
      labelWidth: 1,
      phoneYzm: "",
      travelCardData: {}, // 选中支付的旅游卡
      travelCardLists: [], // 旅游卡列表showUseCoupon:false,
    };
  },
  filters: {
    phoneFilters: function (val) {
      if (!val) return "";
      let value = val.toString();
      return (
        value.substr(0, 3) + " " + value.substr(3, 4) + " " + value.substr(7)
      );
    },
  },
  computed: {
    ...mapState({
      destineArr: (state) => {
        if (state.home.destineArr.orderInfo) {
          return state.home.destineArr;
        } else {
          let destineArr = JSON.parse(sessionStorage.getItem("destineArr"));
          return destineArr;
        }
      },
      lingpiaouserList: (state) =>
        state.home.lingpiaouserList ||
        JSON.parse(sessionStorage.getItem("lingpiaouserList")),
      obj: (state) => {
        let obj = {};
        for (
          let i = state.home.destineArr.lingpiaouserList.length - 1;
          i >= 0;
          i--
        ) {
          obj[i] = false;
        }
        return obj;
      },
      lingpiaouser: (state) =>
        state.home.lingpiaouser || sessionStorage.getItem("lingpiaouser"),
    }),
    firstStepShow: function () {
      return sessionStorage.getItem("firstStepShow");
    },
    ruleValidate() {
      const validatePhoneYzm = (rule, value, callback) => {
        if (!value) {
          callback(new Error("验证码不能为空"));
        } else {
          callback();
        }
      };

      let tiaojian1 = {
          required: true,
          message: "请输入证件上的实际姓名",
          trigger: "blur",
        },
        tiaojian2 = {
          required: true,
          message: "请输入正确的证件号码",
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          trigger: "blur",
        },
        tiaojian22 = {
          required: false,
          message: "请输入正确的证件号码",
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          trigger: "blur",
        },
        tiaojian3 = {
          required: true,
          message: "请输入正确的手机号码",
          pattern:
            /^(13[0-9]|14[5-9]|15[0-9]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/,
          trigger: "blur",
        },
        tiaojianyzm = {
          required: true,
          validator: validatePhoneYzm,
          trigger: "blur",
        };

      let obj = {};
      let arr1 = [];
      arr1[0] = tiaojian1;
      arr1[1] = {
        type: "string",
        max: 20,
        message: "名字不能超过20个字符",
        trigger: "blur",
      };
      let arr2 = [];
      arr2[0] = tiaojian2;
      let arr3 = [];
      arr3[0] = tiaojian3;
      let arryzm = [];
      arryzm[0] = tiaojianyzm;

      for (let i = this.destineArr.numCount; i > 0; i--) {
        obj["name" + i] = arr1;
        obj["ID" + i] = arr2;
      }
      obj["namezj"] = arr1;
      obj["IDzj"] = [tiaojian22];
      obj["phoneNumberzj"] = arr3;
      obj["verificationCode"] = arryzm;
      return obj;
    },
    isShowContact() {
      return this.userName;
    },
  },
  watch: {
    useCoupon(newValue) {
      if (newValue) {
        this.couponMoney = this.couponInfor.discounted_price;
        this.couponId = this.couponInfor.cid;
      } else {
        this.couponMoney = 0;
        this.couponId = "";
      }
    },
    "destineArr.xjcount": {
      handler: function (val) {
        if (this.showCoupon && val < this.couponInfor.discounted_price) {
          this.couponMoney = 0;
          this.useCoupon = false;
          this.useDisabled = true;
        } else if (
          this.showCoupon &&
          val >= this.couponInfor.discounted_price
        ) {
          this.useDisabled = false;
          if (this.useCoupon)
            this.couponMoney = this.couponInfor.discounted_price;
        }
      },
    },
  },
  mounted() {
    this.viewCoupon();
    this.routeType === "lc" ? this.getuserInfo() : "";
    this.routeType === "lc" ? this.getMyTravelCardLists() : "";
  },
  methods: {
    // 查看是否有优惠券
    async viewCoupon() {
      if (!this.userName) return;
      let orderInfoObject = this.destineArr.orderInfo[0];
      const params = {
        usid: this.userName,
        icrowdkindid: orderInfoObject.icrowdkindid,
        orderAmount: 100000,
      };
      this.isShowLoading = true;
      let res = await this.$api.get(
        this.lee + "/ticket/coupon/v1/viewAvailableCoupons",
        params
      );
      if (res.msg === "success" && res.data.length > 0) {
        this.couponInfor = res.data[0];
        this.useDisabled =
          this.couponInfor.discounted_price > this.destineArr.xjcount;
        this.showCoupon = this.useCouponDisabled();
      }
      this.isShowLoading = false;
    },
    // 比较优惠券日期，是否能用，可以true
    useCouponDisabled() {
      let choiceTime = new Date().format("yyyy-MM-dd");
      if (
        Date.parse(choiceTime) >=
          Date.parse(this.couponInfor.start_available_time) &&
        Date.parse(choiceTime) <=
          Date.parse(this.couponInfor.end_available_time)
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 比较优惠券日期，是否能用，可以true
    canUseCoupon(total) {
      let canUse = parseFloat(total) >= this.couponInfor.preferential_amount;
      if (!canUse) useCoupon = false;
      return canUse;
    },

    toggleShowReservations: function (content) {
      this.$Modal.info({
        title: "预订说明",
        content: content ? content : "暂无预定说明",
      });
      // this.showReservations = !this.showReservations;;
    },
    chooseLpr() {
      // this.$refs['totalInfo'].resetFields();
      const lprxx = JSON.parse(this.lprxx);
      this.totalInfo["namezj"] = lprxx.username;
      this.totalInfo["phoneNumberzj"] = lprxx.mobile;
      this.totalInfo["IDzj"] = lprxx.zjhm;
      this.modal1 = false;
    },
    chooseLpr1() {
      const lprxx1 = JSON.parse(this.lprxx1);
      if (this.personNum > 1) {
        for (let i in this.totalInfo) {
          if (this.totalInfo[i] === lprxx1.zjhm && i !== "IDzj") {
            this.$req.showMessageModal(this, "入园人身份证不能重复", 2);
            return;
          }
        }
      }
      this.totalInfo["name" + this.personNum] = lprxx1.username;
      this.totalInfo["phoneNumber" + this.personNum] = lprxx1.mobile;
      this.totalInfo["ID" + this.personNum] = lprxx1.zjhm;
      if (this.disableArr.indexOf(lprxx1.zjhm) === -1) {
        this.disableArr.push(lprxx1.zjhm);
        if (this.ableObj[this.personNum] !== -1) {
          let indexofnum = this.disableArr.indexOf(
            this.ableObj[this.personNum]
          );
          this.disableArr.splice(indexofnum, 1);
        }
      }
      this.ableObj[this.personNum] = lprxx1.zjhm;
      this.modal2 = false;
    },
    checkGroupChange: function (value, index) {
      value.select = value.select ? false : true;
      this.obj[index] = value.select;
      if (value.select) {
        this.writeNum++;
        this.checkList.push(value);

        let n = this.writeNum;
        value.n = n;
        if (n <= this.destineArr.numCount) {
          this.totalInfo["name" + n] = value.username;
          this.totalInfo["ID" + n] = value.zjhm;
          // this.totalInfo['phoneNumber'+n] = value.mobile;
        }
      } else {
        this.writeNum--;
        reduceObjInArr(this.checkList, value);
        if (value.n) {
          let n = value.n;
          this.totalInfo["name" + n] = "";
          this.totalInfo["ID" + n] = "";
          // this.totalInfo['phoneNumber'+n] = '';
          value.n = "";
        }
      }
    },
    checksingleChange(value) {
      value.iselect = value.iselect ? false : true;
      this.singleFlag = !this.singleFlag;
      if (value.iselect) {
        this.totalInfo["namezj"] = value.username;
        this.totalInfo["IDzj"] = value.zjhm;
        this.totalInfo["phoneNumberzj"] = value.mobile;
      } else {
        this.totalInfo["namezj"] = "";
        this.totalInfo["IDzj"] = "";
        this.totalInfo["phoneNumberzj"] = "";
      }
    },
    checkMore: function () {
      this.maxShow = 10000;
    },
    /**
     * 切换旅游卡
     */
    handleTravelCardChange(key) {
      this.travelCardData = {
        ...this.travelCardLists.filter((item) => item.key === key)[0],
      };
    },
    /*
     * 旅游卡专享--购票人信息
     * 用户信息自动获取
     * this.routeType === 'lc'存在表示是从旅游卡专享进行购票,不存在表示从景区门票进行购票
     */
    async getuserInfo() {
      this.isShowLoading = true;
      let res = await this.$api.get(
        this.lee + "/tourcard/tourcard/v1/getUserRealNameInfo",
        {
          usid: this.userName,
        }
      );
      if (res.code === 200 && this.routeType === "lc") {
        this.isShowLoading = false;
        (this.lc = {
          IDzj: res.data.idNum,
          phoneNumberzj: res.data.phone,
        }),
          (this.totalInfo = {
            namezj: res.data.realName, //购票人姓名
            IDzj: res.data.idNum.replace(/^(\d{6})\d{8}(\d+)/, "$1********$2"), //购票人身份证
            phoneNumberzj: res.data.phone.replace(
              /^(\d{3})\d{4}(\d+)/,
              "$1****$2"
            ), //购票人手机号码
          });
      } else if (res.code === 400) {
        this.isShowLoading = false;
        this.$Modal.info({
          title: "温馨提示",
          content: res.msg || "请求失败",
        });
      } else {
        this.isShowLoading = false;
        throw new Error("error");
      }
    },
    /**
     * 旅游卡专享--获取当前用户已购买旅游卡列表
     * this.travelCardLists 旅游卡下拉列表
     **/
    async getMyTravelCardLists() {
      this.isShowLoading = true;
      const res = await this.$api.get2(
        `${this.lee}/tourcard/tourcard/v1/getUserCard?${this.QS.stringify({
          usid: this.userName,
          iscenicid: this.destineArr.orderInfo[0].iscenicid,
          access_token: sessionStorage.getItem("name"),
        })}`
      );
      let time = new Date();
      time.setHours(0);
      time.setMinutes(0);
      time.setSeconds(0);
      time.setMilliseconds(0);
      // let today = new Date().getTime()
      console.log(res.data);
      if (res.code === 200 && res.data.length > 0) {
        this.isShowLoading = false;
        this.travelCardLists = res.data.map((item) => {
          //periodEndDate
          if (new Date(item.periodEndDate).getTime() >= time) {
            item.value = item.name;
            item.key = item.cardNumber;
          }
          return item;
        });
        // this.travelCardData = this.travelCardLists && this.travelCardLists[0]
        //赋值解构，解决应用改变原数组问题
        this.travelCardData = {
          ...(this.travelCardLists && this.travelCardLists[0]),
        };
      }
    },

    /*
     * 旅游卡专享保存订单--去支付
     */
    async goToBuy() {
      this.isShowLoading = true;
      let { orderInfo, playtime } = this.destineArr;
      let data = orderInfo[0];

      let bodyParams = [
        {
          iscenicid: data.iscenicid, //景区id
          itickettypeid: data.itickettypeid, //产品id
          icrowdkindid: data.icrowdkindid, //票种类
          num: 1, //数量
          playtime: playtime, //游玩日期
          icrowdkindpriceid: data.icrowdkindpriceid, //售价id
        },
      ];
      let lpr = {
        daoyou: this.totalInfo.namezj, //联系人姓名
        mobile: this.lc.phoneNumberzj, //手机号码
        zjhm: this.lc.IDzj, //证件号码
        ornote1: this.totalInfo.namezj, //领票人姓名
        zjlb: "01", //证件类别
      };
      let params = {
        access_token: sessionStorage.getItem("name"),
        lpr: JSON.stringify(lpr), //领票人对象
        orderChannel: "PC", //下单渠道
        channelName: "环球雅途", //渠道名
        usid: this.userName, //用户id
        tourCardNo: this.travelCardData.key, //旅游卡号
      };
      let res = await this.$http.post(
        `${this.lee}/tourcard/tourcard/v1/newSaveOrder?a=1&${this.QS.stringify(
          params
        )}`,
        bodyParams,
        params
      );
      this.isShowLoading = false;
      if (!res) return false;
      if (res.data.code === 200) {
        this.$router.push({
          name: "personalUserHome",
        });
      } else {
        this.$Modal.info({
          title: "温馨提示",
          content: res.data.msg,
        });
      }
    },

    /*
     * 景区门票订单保存
     */
    async handleSubmit(name, formData) {
      this.spinShow = true;
      let that = this,
        arr = [];
      for (let i = 1; i <= that.destineArr.numCount; i++) {
        //判断入园人身份证是否重复
        if (that.totalInfo["ID" + i]) {
          if (arr.indexOf(that.totalInfo["ID" + i]) === -1) {
            arr.push(that.totalInfo["ID" + i]);
          } else {
            this.$req.showMessageModal(this, "入园人身份证号不能重复", 1);
            this.spinShow = false;
            return;
          }
        }
      }

      this.$refs[name].validate(async (valid) => {
        if (valid) {
          //-----散客直接从景区下单,领票人信息-------------------------------------------------------------------------------
          let lpr = {
            zjlb: "01",
            ornote1: formData.namezj, // 领票人姓名
            zjhm: formData.IDzj, // 领票人身份证ID
            mobile: formData.phoneNumberzj, //领票人手机号码
            // url:'jcfx.yilvbao.cn',
            url: window.location.hostname,
          };
          let orderInfoObject = that.destineArr.orderInfo[0];

          //-----散客从分销商下单,领票人信息--------------------------------------------------------------------------------
          let lprInfoJson = [
            {
              couponId: this.couponId, // 优惠券id
              daoyou: formData.namezj, //姓名
              iscenicid: orderInfoObject.iscenicid, //景区id
              mobile: formData.phoneNumberzj, //手机号
              rzti: that.destineArr.playtime, //游览日期
              zjhm: formData.IDzj, //证件号码
              zjlb: "01", //证件类别
            },
          ];

          //-----散客从分销商下单,订单信息----------------------------------------------------------------------------------
          let orderPojoJson = [
            {
              basnum: 0,
              freenum: 0,
              icrowdkindid: orderInfoObject.icrowdkindid, //票种
              icrowdkindpriceid: orderInfoObject.priceId, //人群种类价格id
              ipeoplenumrange: that.firstStepShow, //是否实名制
              iscenicid: orderInfoObject.iscenicid, //景区id
              isenough: true,
              issale: 0,
              itickettypeid: orderInfoObject.itickettypeid, //产品id
              // listingprice: this.rowData.listingprice,
              // mactualsaleprice: this.rowData.mactualsaleprice,
              distributePrice: orderInfoObject.price, //分销商设置售价
              monthpoint: "0",
              numb: orderInfoObject.num, //票数量
              point: "0",
              scheme: 0,
              scnum: 0,
              totalnum: orderInfoObject.num, //票数量
              yearpoint: "0",
              usid: "hqyt", //sessionStorage.getItem('fxsId')     //分销商店铺Id
            },
          ];

          //-----如果是分时预约票，订单信息带上时间参数-----------------------------------------------------------------------
          if (orderInfoObject.timeid) {
            orderPojoJson[0]["fstimeid"] = orderInfoObject.timeid;
            orderPojoJson[0]["fsstarttime"] = orderInfoObject.starttime;
            orderPojoJson[0]["fsendtime"] = orderInfoObject.endtime;
          }

          //-----入园信息（非实名制没有入园信息）----------------------------------------------------------------------------
          let realnames = []; //散客从景区下单，实名制票入园人信息
          let distributeTouristsJson = []; //散客从分销商下单，实名制票入园人信息
          for (let i = 1; i <= that.destineArr.numCount; i++) {
            realnames.push({
              itickettypeid: orderInfoObject.itickettypeid,
              iscenicid: orderInfoObject.iscenicid,
              icrowdkindid: orderInfoObject.icrowdkindid,
              zjtp: "01",
              cname: that.totalInfo["name" + i],
              idcard: that.totalInfo["ID" + i],
            });
            distributeTouristsJson.push({
              tourName: that.totalInfo["name" + i], //入园人姓名
              idNumber: that.totalInfo["ID" + i], //入园人身份证
              scenicId: orderInfoObject.iscenicid, //景区id
              icrowdkindPriceId: orderInfoObject.priceId, //商品价格id
            });
          }
          let realnameObj = JSON.stringify([{ realnames }]);

          //-----景区门票订单信息-----------------------------------------------------------------------------------------
          let orderInfo = [];
          let obj = {};
          that.destineArr.orderInfo.forEach(function (data) {
            obj = {
              playtime: that.destineArr.playtime,
              icrowdkindid: data.icrowdkindid,
              itickettypeid: data.itickettypeid,
              priceId: orderInfoObject.priceId,
              iscenicid: data.iscenicid,
              num: data.num,
              starttime: data.starttime || "",
              endtime: data.endtime || "",
              timeid: data.timeid || "",
            };
            orderInfo.push(obj);
            obj = {};
          });

          //-----常用联系人信息-------------------------------------------------------------------------------------------
          let aaa = {
            cyuser: formData.cyuser ? true : "", //是否添加常用联系人
            lpr: JSON.stringify(lpr),
            note: formData.mask || "",
            realnames: that.firstStepShow === "1" ? realnameObj : "",
            url: window.location.hostname,
          };

          let urlParams = {
            usid: sessionStorage.getItem("userName"),
            lprInfoJson: JSON.stringify(lprInfoJson),
            orderPojoJson: JSON.stringify(orderPojoJson),
            orderChannel: "PC",
            channelName: orderInfoObject.szscenicname,
            distributeTouristsJson: JSON.stringify(distributeTouristsJson),
            cyuser: formData.cyuser ? true : "", //是否添加常用联系人
          };
          let paramInfo = JSON.stringify({
            lprlist: lprInfoJson,
            list: orderPojoJson,
            tourist: distributeTouristsJson,
          });

          /**sessionStorage.getItem('name') 【已登录状态】**/
          if (sessionStorage.getItem("name")) {
            /**sessionStorage.getItem('fxsId') 【已登录状态】--分销商登录状态 **/
            if (sessionStorage.getItem("fxsId")) {
              const saveOrderParam = {
                usid: sessionStorage.getItem("userName"),
                fxid: sessionStorage.getItem("fxsId"),
                orderChannel: "PC",
                channelName: orderInfoObject.szscenicname,
                orderInfo: paramInfo,
                remark: formData.mask || "",
                returnUrl: "http://" + window.location.hostname,
                // returnUrl: `http://${ window.location.hostname }/#/my-account/MySalesOrder`
              };
              const bookProductRES = await that.$api.post(
                that.lee + "/ec/distributorShop/v1/bookProductForDistributor",
                urlParams
              );
              that.spinShow = false;
              if (!bookProductRES) return false;
              const saveOrderRES = await that.$api.post(
                this.lee + "/ec/distributorShop/v1/saveOrderForDistributor",
                saveOrderParam
              );
              saveOrderRES.code === 200
                ? window.location.replace(saveOrderRES.data.view)
                : "";
            } else {
              /**【已登录状态】--散客游客登录状态**/
              let MyOrderDetailParam = {
                // ...aaa,
                usid: sessionStorage.getItem("userName"),
                orderChannel: "PC",
                channelName: orderInfoObject.szscenicname,
                orderInfo: paramInfo,
                remark: formData.mask || "",
                cyuser: formData.cyuser ? true : "",
                returnUrl: `http://${window.location.hostname}/#/my-personalUser/MyOrderDetailsPage?usid=${this.userName}`,
              };
              that
                .saveOrderInfo({
                  paramsData: MyOrderDetailParam,
                  params: orderInfo,
                })
                .then((saveOrderResData) => {
                  that.spinShow = false;
                  // if (saveOrderResData.code === 200)
                  //   window.location.replace(saveOrderResData.data.view);
                  if (saveOrderResData.code === 200) {
                    if (saveOrderResData.data.directFlag) {
                      this.$router.push({
                        name: "distributorDetails",
                        query: {
                          orid: saveOrderResData.data.orid,
                          usid: saveOrderResData.data.usid,
                          ordersource: "PC",
                          einvoicestatus: 0,
                        },
                      });
                    } else {
                      window.location.replace(saveOrderResData.data.view);
                    }
                  }
                })
                .catch(() => {
                  that.spinShow = false;
                  console.log("请求失败");
                });
            }
          } else {
            /**【未登录状态】**/
            let paramsData = {
              flag: "01", //电商
              url: window.location.hostname,
              // url:'jcfx.yilvbao.cn',
            };
            let params = {
              mobile: formData.phoneNumberzj,
              zjlb: "01",
              zjhm: formData.IDzj,
              ornote1: formData.namezj,
              ornote2: parseInt(formData.verificationCode),
            };
            /**【未登录状态】，checkLogin检测当前用户登录状态 response.data.type：01（验证码校验失败）、02（老用户登录）、03（新用户登录） **/
            that
              .checkLogin({ paramsData: paramsData, params: params })
              .then((response) => {
                if (response.code !== 200) {
                  that.spinShow = false;
                  that.$req.showMessageModal(that, "检查登录接口出错", 1);
                  return;
                }
                switch (response.data.type) {
                  case "01":
                    that.spinShow = false;
                    that.$Modal.error({
                      title: "温馨提示",
                      content: "验证码校验失败",
                    });
                    break;

                  case "02":
                    let uesrIfon = response.data.custom;
                    sessionStorage.setItem(
                      "totalInfo",
                      JSON.stringify(that.totalInfo)
                    );
                    sessionStorage.setItem("payFlag", "1"); //用来判断用户是否来自下单后跳转到登录页面
                    sessionStorage.setItem("userName", uesrIfon.usid);
                    uesrIfon.note6
                      ? sessionStorage.setItem("nickname", uesrIfon.note6)
                      : sessionStorage.setItem("nickname", uesrIfon.usid); // 分销商等级
                    sessionStorage.setItem("lgtp", uesrIfon.lgtp); //存储用户状态 01：散客；02：分销商
                    sessionStorage.setItem("ustp", uesrIfon.ustp);
                    const tokenData = that.QS.stringify({
                      username: uesrIfon.usid,
                      password: uesrIfon.password,
                      grant_type: "password",
                      scope: "app",
                      client_id: "android",
                      client_secret: "android",
                    });
                    that.$http
                      .post(`${that.baseURL}/uaa/oauth/token`, tokenData)
                      .then(async (res) => {
                        if (res.status !== 200) {
                          that.$Modal.warning({
                            title: "温馨提示",
                            content: "获取token信息失败，请重新操作",
                          });
                          return false;
                        }
                        sessionStorage.setItem("name", res.data.access_token); // 存储 token
                        paramsData = {
                          usid: uesrIfon.usid,
                          returnUrl: `http://${window.location.hostname}/#/my-personalUser/MyOrderDetailsPage?usid=${uesrIfon.usid}`,
                          orderChannel: "PC",
                          channelName: orderInfoObject.szscenicname,
                          orderInfo: paramInfo,
                          remark: formData.mask || "",
                          cyuser: formData.cyuser ? true : "",
                        };
                        that
                          .saveOrderInfo({
                            paramsData: paramsData,
                            params: orderInfo,
                            istoken: true,
                          })
                          .then((saveOrderRes) => {
                            that.spinShow = false;
                            // if (saveOrderRes.code === 200)
                            //   window.location.replace(saveOrderRes.data.view);
                            if (saveOrderRes.code === 200) {
                              if (saveOrderRes.data.directFlag) {
                                this.$router.push({
                                  name: "distributorDetails",
                                  query: {
                                    orid: saveOrderRes.data.orid,
                                    usid: saveOrderRes.data.usid,
                                    ordersource: "PC",
                                    einvoicestatus: 0,
                                  },
                                });
                              } else {
                                window.location.replace(saveOrderRes.data.view);
                              }
                            }
                          })
                          .catch(() => {
                            that.spinShow = false;
                          });
                      });
                    break;

                  case "03":
                    let paramsData = {}; //03:未注册的用户自动注册登录
                    let custom = response.data.custom;
                    sessionStorage.setItem("userName", custom.usid); // 用户名
                    sessionStorage.setItem("lgtp", custom.lgtp); // 用户类别
                    sessionStorage.setItem("ustp", custom.ustp); // 分销商等级
                    custom.note6
                      ? sessionStorage.setItem("nickname", custom.note6)
                      : sessionStorage.setItem("nickname", custom.usid); // 分销商等级
                    //----------------------获取当前用户token start------------------------------
                    const tokenParam = {
                      username: custom.usid,
                      password: custom.password,
                      grant_type: "password",
                      scope: "app",
                      client_id: "android",
                      client_secret: "android",
                    };
                    urlParams.usid = custom.usid; //重新获取一下用户名信息
                    that.$http
                      .post(
                        that.baseURL + "/uaa/oauth/token",
                        that.QS.stringify(tokenParam)
                      )
                      .then(async (res) => {
                        that.spinShow = false;
                        if (res.status !== 200) {
                          this.$req.showMessageModal(
                            this,
                            "未获取token信息，请刷新后重试",
                            2
                          );
                          return false;
                        }
                        sessionStorage.setItem("name", res.data.access_token); // 存储 token
                        let saveOrderInfoParm = {
                          usid: response.data.custom.usid,
                          fxid: sessionStorage.getItem("fxsId"),
                          orderInfo: paramInfo,
                          orderChannel: "PC",
                          channelName: orderInfoObject.szscenicname,
                          remark: formData.mask || "",
                          returnUrl: "http://" + window.location.hostname,
                          // returnUrl: `http://${ window.location.hostname }/#/my-account/MySalesOrder`
                        };
                        if (sessionStorage.getItem("fxsId")) {
                          const distributorRes = await that.$api.post(
                            `${that.lee}/ec/distribute/v1/bookProductForDistributor`,
                            urlParams
                          );
                          if (!distributorRes) return false; //校验分销商订单数据
                          const saveOrder03 = await that.$api.post(
                            `${that.lee}/ec/distributorShop/v1/saveOrderForDistributor`,
                            saveOrderInfoParm
                          );
                          saveOrder03.code === 200
                            ? window.location.replace(saveOrder03.data.view)
                            : "";
                        } else {
                          paramsData = {
                            // ...aaa,
                            usid: response.data.custom.usid,
                            returnUrl: `http://${window.location.hostname}/#/my-personalUser/MyOrderDetailsPage?usid=${response.data.custom.usid}`,
                            orderChannel: "PC",
                            channelName: orderInfoObject.szscenicname,
                            orderInfo: paramInfo,
                            remark: formData.mask || "",
                            cyuser: formData.cyuser ? true : "",
                            // returnUrl: `http://${ window.location.hostname}`
                          };
                          that
                            .saveOrderInfo({
                              paramsData: paramsData,
                              params: orderInfo,
                            })
                            .then((response) => {
                              // if (response.code === 200)
                              //   window.location.replace(response.data.view);
                              if (response.data.directFlag) {
                                this.$router.push({
                                  name: "distributorDetails",
                                  query: {
                                    orid: response.data.orid,
                                    usid: response.data.usid,
                                    ordersource: "PC",
                                    einvoicestatus: 0,
                                  },
                                });
                              } else {
                                window.location.replace(response.data.view);
                              }
                            })
                            .catch(() => {
                              console.log("保存订单失败");
                            });
                        }
                      });
                    break;
                }
              })
              .catch(function (err) {
                that.$req.showMessageModal(that, err, 1);
                that.spinShow = false;
              });
          }
        } else {
          that.$req.showMessageModal(that, "请完善信息", 2);
          that.spinShow = false;
        }
      });
    },
    handleSubmit1(name, formData) {
      let that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          that
            .tologin({
              usid: formData.phoneNumbeLogin,
              pwd: formData.passwordLogin,
            })
            .then(function (response) {
              sessionStorage.setItem("notredirect", "1");
              that.getToken({ paramsData: response }).then(function () {
                that.modalLogin = false;
                if (that.isSelect) {
                  let obj = {
                    usid: formData.phoneNumbeLogin,
                    pwd: formData.passwordLogin,
                    url: window.location.hostname,
                  };
                  sessionStorage.setItem("userInfo", JSON.stringify(obj));
                } else {
                  sessionStorage.removeItem("userInfo");
                }
              });
            });
        } else {
          return;
        }
      });
    },
    checkRequire(n) {
      console.log(1);
      let ID = this.totalInfo["ID" + n];
      console.log(ID);
      let N = parseInt(n);
      if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(ID)) {
        console.log(2);
        this.ableObj[N] = ID;
        this.disableArr.push(ID);

        // let arr = distinct(this.disableArr);
        // this.disableArr = arr;
        console.log(this.disableArr);
      } else {
        if (this.ableObj[N] !== -1) {
          let indexofnum = this.disableArr.indexOf(this.ableObj[N]);
          this.disableArr.splice(indexofnum, 1);
          console.log(this.disableArr);
          this.ableObj[N] = -1;
        }
      }
    },
    async getYzm() {
      let that = this,
        seconds = 120;
      this.yzmObj.timelimit = true;
      setTimeout(function time() {
        if (seconds <= 0) {
          that.yzmObj.tishi = "获取验证码";
          that.yzmObj.timelimit = false;
          return;
        }
        that.yzmObj.tishi = seconds + "s后重新获取";
        seconds--;
        setTimeout(time, 1000);
      }, 1000);

      let wait = await this.sendVerificationCode({
        phoneNumber: this.totalInfo.phoneNumberzj,
        type: "0018",
      }).then((res) => {
        if (res.code === 200) {
          this.phoneYzm = res.msg;
          return true;
        } else {
          this.$req.showMessageModal(this, "获取验证码失败", 1);
        }
      });

      if (!wait) {
        seconds = 0;
      }
    },
    choosePerson() {
      if (!this.lingpiaouserList.length) {
        this.$req.showMessageModal(this, "暂无常用联系人可供选择", 2);
        return false;
      }
      if (!this.userName) {
        this.modalLogin = true;
        if (this.totalInfo.phoneNumberzj) {
          this.totalInfo1.phoneNumbeLogin = this.totalInfo.phoneNumberzj;
        }
      } else {
        this.modal1 = true;
        this.totalInfo1.phoneNumbeLogin = "";
        this.totalInfo1.passwordLogin = "";
      }
    },
    choosePerson1(n) {
      if (!this.lingpiaouserList.length) {
        this.$req.showMessageModal(this, "暂无常用联系人可供选择", 2);
        return false;
      }
      this.lprxx1 = null;
      if (!this.userName) {
        this.modalLogin = true;
        if (this.totalInfo.phoneNumberzj) {
          this.totalInfo1.phoneNumbeLogin = this.totalInfo.phoneNumberzj;
        }
      } else {
        this.personNum = n;
        if (!this.ableObj[this.personNum]) {
          this.ableObj[this.personNum] = -1;
        }
        this.modal2 = true;
        this.totalInfo1.phoneNumbeLogin = "";
        this.totalInfo1.passwordLogin = "";
      }
    },
    hideModal(modal) {
      //关闭常用联系人弹窗
      if (modal === "modal1") {
        this.modal1 = false;
      } else if (modal === "modal2") {
        this.modal2 = false;
      }
    },
    getToken(tokenData) {
      return new Promise((resolve) => {
        this.$http
          .post(this.baseURL + "/uaa/oauth/token", this.QS.stringify(tokenData))
          .then((res) => {
            if (res.status === 200) {
              sessionStorage.setItem("name", res.data.access_token); // 存储 token
              resolve();
            } else {
              this.$req.showMessageModal(
                this,
                "未获取token信息，请刷新后重试",
                2
              );
            }
          })
          .catch((err) => {
            this.$req.showMessageModal(this, "账号不存在", 2);
          });
      });
    },
    ...mapMutations(["orderAdd", "orderReduce", "orderInput", "getdestineArr"]),
    ...mapActions([
      "sendVerificationCode",
      "checkLogin",
      "saveOrderInfo",
      "tologin",
      "getToken",
    ]),
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        let input = document.createElement("input");
        let div = document.createElement("div");
        let textdiv = document.createElement("div");
        if ("placeholder" in input) {
        } else {
          textdiv.innerHTML = binding.value;
          div.appendChild(textdiv);
          div.style.position = "relative";
          textdiv.style.position = "absolute";
          textdiv.style.top = "7px";
          textdiv.style.left = "8px";
          textdiv.style.color = "#C5C8D7";
          textdiv.style.zIndex = "999";
          el.parentNode.insertBefore(div, el);
          let input = el.getElementsByTagName("input")[0];
          input.onfocus = function () {
            div.style.display = "none";
          };
          input.onblur = function () {
            div.style.display = this.value != "" ? "none" : "block";
          };
        }
      },
    },
  },
  created() {
    if (sessionStorage.getItem("totalInfo") && this.userName) {
      this.totalInfo = JSON.parse(sessionStorage.getItem("totalInfo"));
      sessionStorage.removeItem("totalInfo");
    }
  },
};
</script>

<style scoped lang="less">
form {
  position: relative;
}
.scope-first-container {
  min-width: 1200px;
  width: 62.5%;
  padding: 56px 64px;
  background: #fff;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  margin: 20px auto;
  color: #5e5e60;
  p {
    font-size: 14px;
    color: #191919;
    font-weight: 700;
  }
  h3 {
    font-size: 20px;
    height: 20px;
    line-height: 1;
    color: #191919;
    margin-bottom: 32px;
    font-family: SourceHanSansCN-Medium;
  }
  .pay-money {
    color: #ff8314;
    span:nth-child(1) {
      font-size: 20px;
      height: 20px;
      line-height: 1;
      font-weight: 500;
    }
    span:nth-child(2) {
      font-size: 32px;
      height: 32px;
      line-height: 1;
      margin-left: 4px;
    }
  }
  .contacts {
    position: relative;
    z-index: 101;
    height: 116px;
    border: 1px solid #ececec;
    margin-bottom: 32px;
    padding: 20px 24px;
    background: #fff;
    li {
      float: left;
      width: 64px;
      height: 14px;
      background: #ccc;
      margin: 12px 32px 12px 0;
    }
  }
  h4 {
    font-size: 14px;
    height: 14px;
    line-height: 1;
    color: #191919;
    margin-bottom: 30px;
  }
  .submit-order {
    background: #4b7ff0;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    width: 240px;
    height: 40px;
    font-size: 16px;
    &:hover {
      background: #306bea;
    }
  }
  .bottom-item {
    margin-top: 100px;
  }
  .bottom-item:after {
    content: ".";
    display: block;
    font-size: 0;
    clear: both;
    height: 44px;
    visibility: inherit;
  }

  .inline-block-h3 {
    display: inline-block;
    margin-right: 50px;
  }
  .topContacts {
    font-size: 14px;
    color: #4b7ff0;
    height: 14px;
    line-height: 1;
    /*text-align: right;*/
    display: inline-block;
    cursor: pointer;
  }
  .numInput-item {
    button {
      &:focus {
        box-shadow: none;
      }
    }
    input:focus {
      box-shadow: none;
    }
  }
}
.adult-ticket {
  margin: 0 9px;
}
.reservations {
  font-size: 12px;
  color: #5e5e60;
  margin-left: 8px;
  cursor: pointer;
}
.couponZoon {
  height: 100px;
  line-height: 100px;
  color: #ff8314;
  .ivu-checkbox-wrapper {
    font-size: 14px;
  }
}
hr {
  margin-top: 100px;
  margin-bottom: 54px;
  background: #ececec;
  height: 1px;
  border: none;
}
.contact-div {
  margin: 0 10px;
  padding: 10px;
  height: 275px;
  border: 1px solid #000;
  overflow-y: auto;
}
.login-div {
  width: 275px;
  margin: auto;
}
.mg1 {
  margin-top: 30px;
}
.ml1 {
  margin-left: 55px;
}
.ml2 {
  margin-left: 85px;
}
.mb1 > label {
  margin: 0 0 20px 0;
}
.span1 {
  width: 60px;
  display: inline-block;
}
</style>
